// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invCertificateTypeId } from './InvCertificateType';
import { invSupplierId } from './InvSupplier';
import { invProductId } from './InvProduct';
import { invItemId } from './InvItem';
import { calendarDate } from '../../calendar-date';
import { z } from 'zod';
export const invCertificateId = (z.number());
export const invCertificate = z.object({
    id: invCertificateId,
    certificate_type_id: invCertificateTypeId,
    supplier_id: invSupplierId.nullable(),
    product_id: invProductId.nullable(),
    item_id: invItemId.nullable(),
    issuing_body: z.string().nullable(),
    valid_from: calendarDate.nullable(),
    valid_until: calendarDate.nullable(),
    file_path: z.string().nullable(),
    created_by: z.number().nullable(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
});
export const invCertificateInitializer = z.object({
    id: invCertificateId.optional(),
    certificate_type_id: invCertificateTypeId,
    supplier_id: invSupplierId.optional().nullable(),
    product_id: invProductId.optional().nullable(),
    item_id: invItemId.optional().nullable(),
    issuing_body: z.string().optional().nullable(),
    valid_from: calendarDate.optional().nullable(),
    valid_until: calendarDate.optional().nullable(),
    file_path: z.string().optional().nullable(),
    created_by: z.number().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
export const invCertificateMutator = z.object({
    id: invCertificateId.optional(),
    certificate_type_id: invCertificateTypeId.optional(),
    supplier_id: invSupplierId.optional().nullable(),
    product_id: invProductId.optional().nullable(),
    item_id: invItemId.optional().nullable(),
    issuing_body: z.string().optional().nullable(),
    valid_from: calendarDate.optional().nullable(),
    valid_until: calendarDate.optional().nullable(),
    file_path: z.string().optional().nullable(),
    created_by: z.number().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
//# sourceMappingURL=InvCertificate.js.map